import { clsx } from 'clsx';
import { MessageSquareText } from 'lucide-react';
import {
  APPOINTMENT_TEMPLATE_OPTIONS,
  type AppointmentTemplateKey,
} from '@/utils/message';

export interface QuickTemplateSelectorProps {
  selected: AppointmentTemplateKey;
  onChange: (template: AppointmentTemplateKey) => void;
  className?: string;
}

export function QuickTemplateSelector({
  selected,
  onChange,
  className,
}: QuickTemplateSelectorProps) {
  return (
    <div className={clsx('flex items-center gap-1.5 overflow-x-auto hide-scrollbar py-0.5', className)}>
      <div className="flex items-center gap-1 text-[10px] text-text-muted font-medium flex-shrink-0 mr-0.5">
        <MessageSquareText size={12} className="text-text-muted" />
        <span>Plantilla:</span>
      </div>
      <div className="flex items-center gap-1 flex-nowrap">
        {APPOINTMENT_TEMPLATE_OPTIONS.map((opt) => {
          const isSelected = selected === opt.key;
          return (
            <button
              key={opt.key}
              type="button"
              onClick={() => onChange(opt.key)}
              className={clsx(
                'px-2 py-0.5 rounded-md text-[11px] font-medium transition-all whitespace-nowrap cursor-pointer',
                isSelected
                  ? 'bg-brand-primary/15 text-brand-primary border border-brand-primary/30 font-semibold shadow-2xs'
                  : 'bg-surface-secondary/80 text-text-secondary hover:text-text-primary hover:bg-surface-secondary border border-border/80'
              )}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
